export const ROUTE_LOGIN = "/login";
export const LOGIN = "/login/:token?";
export const FORGOT_PASSWORD = "/forgot-password";

export const PORTALS = "/portals";
export const CREATE_PORTAL = PORTALS + "/create/:licensed(licensed)?";

export const COURSES = "/courses";
export const COURSE = "/course";
export const COURSE_ID = COURSE + "/:courseId";
export const COURSE_SESSION = COURSE_ID + "/session/:courseSessionId";

export const PORTAL = "/portal";
export const PORTAL_ID = PORTAL + "/:portalId";

export const PORTAL_USERS = PORTAL_ID + "/users";
export const PORTAL_ADD_USER = PORTAL_USERS + "/add";
export const PORTAL_IMPORT_USERS = PORTAL_USERS + "/import";
export const PORTAL_USERS_ENROL = PORTAL_USERS + "/enrol";
export const PORTAL_USER =
  PORTAL_ID + "/user/:userId(-?\\d+)/:progress(progress)?/:courseId(-?\\d+)?";

const PORTAL_REPORT = PORTAL_ID + "/report";
export const PORTAL_PCAT_REPORT = PORTAL_REPORT + "/pcat";
export const PORTAL_COURSE_REPORT =
  PORTAL_REPORT +
  "/:tab" +
  "/course/:courseId" +
  "/:licenceId(\\d+|overview|all)" +
  "/:userId(\\d+)?" +
  "/:progress(progress)?" +
  "/:progressCourseId(-?\\d+)?";
export const PORTAL_CONFIGURE = PORTAL_ID + "/configure";
export const PORTAL_LICENCES = PORTAL_CONFIGURE + "/licensing";

export const PORTAL_CUSTOMISEABLEITEMS =
  PORTAL_ID + "/configure/customisable-items/:tab?/:itemId(\\d+)?";

export const PORTAL_RESOURCES = PORTAL_CONFIGURE + "/resources/:reset(reset)?";

export const PORTAL_RESOURCE_GROUP = PORTAL_RESOURCES + "/group/:groupId";
export const PORTAL_ADD_RESOURCE = PORTAL_RESOURCE_GROUP + "/add-resource";

export const PORTAL_RESOURCE = PORTAL_RESOURCE_GROUP + "/resource/:resourceId(-?\\d+)";

export const PORTAL_SETTINGS = PORTAL_CONFIGURE + "/settings";

export const ADMINISTRATORS = "/administrators";

export const ADMINISTRATOR = "/administrator";
export const ADD_ADMINISTRATOR = ADMINISTRATOR;
export const ADMINISTRATOR_ID = ADMINISTRATOR + "/:adminId(-?\\d+)?";

export const CONFIGURE = "/configure";
export const CONFIGURE_CUSTOMITEMS = CONFIGURE + "/custom-items/:tab?/:itemId(\\d+)?";

export const RESOURCES = CONFIGURE + "/resources";

export const RESOURCE_SET = RESOURCES + "/set";
export const RESOURCE_SET_ID = RESOURCE_SET + "/:setId";

export const RESOURCE_GROUP_ID = RESOURCE_SET_ID + "/group/:groupId";
export const RESOURCE_GROUP_ADD_RESOURCE = RESOURCE_GROUP_ID + "/add-resource";

export const RESOURCE_ID = RESOURCE_GROUP_ID + "/resource/:resourceId";

export const LMS_CLIENTS = "/lms-clients";
export const LMS_ADD_CLIENT = LMS_CLIENTS + "/add";
export const LMS_CLIENT = LMS_CLIENTS + "/:clientId(\\d+)/:licenceKey([a-f0-9]{32})?";

export const DASHBOARD = "/";
export const SEARCH = "/search";
export const OLD_LOGIN = "/Auth/Login";
